import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'
import { log } from 'common-tools/LogHelper'

let actions = {}

actions[actiontypes.Router.Push] = (state, action) => {
  let newState = _.merge({}, state)

  log.Trace('Route Changed', { NewPath: action.payload.pathname })
  newState.currentRoute = action.payload

  return newState
}

actions[actiontypes.Router.AddIndexRoute] = (state, action) => {
  let newState = _.merge({}, state)

  if (_.indexOf(newState.indexRoutes, action.payload) === -1) {
    newState.indexRoutes.push(action.payload)
  }

  return newState
}

export default (state = {
  indexRoutes: [],
  currentRoute: {}
}, action) => {
  if (_.startsWith(action.type, actiontypes.Router.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
